import type { CybusService } from './Service'

type DeviationEventToastKind = 'new' | 'resolved'

/** `id` is synthetic, not the service id - a service can re-deviate after resolving, producing more than one event over time. */
export type DeviationEventToastItem = Readonly<{
    id: string
    kind: DeviationEventToastKind
    serviceId: CybusService['id']
}>

type DeviationCounterToast = Readonly<{ count: number }>

export type DeviationNotificationsAppState = Readonly<{
    deviationEventToasts: ReadonlyArray<DeviationEventToastItem>
    deviationCounterToast: DeviationCounterToast | null
}>

export const selectDeviationEventToasts = (s: DeviationNotificationsAppState): DeviationNotificationsAppState['deviationEventToasts'] => s.deviationEventToasts

export const selectDeviationCounterToast = (s: DeviationNotificationsAppState): DeviationNotificationsAppState['deviationCounterToast'] =>
    s.deviationCounterToast
